module.exports = __webpack_public_path__ + "static/media/Southgrove Kitchen Cooker Base.2f054b56.JPG";